import { render } from "./SliderControl.vue?vue&type=template&id=1ae181e9&scoped=true"
import script from "./SliderControl.vue?vue&type=script&lang=js"
export * from "./SliderControl.vue?vue&type=script&lang=js"

import "./SliderControl.vue?vue&type=style&index=0&id=1ae181e9&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae181e9"]])

export default __exports__